import { render, staticRenderFns } from "./helpItem.vue?vue&type=template&id=4f865600&scoped=true&"
import script from "./helpItem.vue?vue&type=script&lang=js&"
export * from "./helpItem.vue?vue&type=script&lang=js&"
import style0 from "./helpItem.vue?vue&type=style&index=0&id=4f865600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f865600",
  null
  
)

export default component.exports